import React from "react";
import "./barGraph.scss";

interface Props {
  height?: string;
  width?: string;
  barFillColor?: string;
  data: {
    id?: number | string;
    label: string | React.ReactNode;
    percentage: string;
  }[];
  isTextVertical?: boolean;
  loading?: boolean;
  loadingBarsCount?: number;
}


interface BarItemProps {
  id?: number | string;
  label: string | React.ReactNode;
  percentage: string;
  barFillColor: string;
  isTextVertical?: boolean;
  height: string;
}


const BarItem: React.FC<BarItemProps> = React.memo(function BarItem({
  id,
  label,
  percentage,
  barFillColor,
  isTextVertical,
  height,
}) {
  return (
    <div key={id} className="commonBar_barItem">
      <div className="commonBar_barFillWrapper" style={{ height: percentage }}>
        <div className="commonBar_barFill" style={{ background: barFillColor }} />
      </div>

      <div
        className={`commonBar_barLabel ${isTextVertical ? "verticalLabel" : ""}`}
        style={{ width: isTextVertical ? height : "100%" }}
        aria-label={`Bar for ${label} with ${percentage}`}
      >
        {label}
      </div>
    </div>
  );
});

const BarGraph: React.FC<Props> = ({
  height = "214px",
  width = "248px",
  data,
  barFillColor = "#73D7C3",
  isTextVertical = false,
  loading = false,
  loadingBarsCount = 3,
}) => {
  if (loading)
    return (
      <div className="commonBar_container" style={{ height, width }}>
        {Array(loadingBarsCount)
          ?.fill("")
          .map((_, index) => (
            <div key={index} className="commonBar_loaderBar" />
          ))}
      </div>
    );

  if (!data?.length)
    return (
      <div className="commonBar_container noData" style={{ height, width }}>
        {Array(loadingBarsCount)
          ?.fill("")
          .map((_, index) => (
            <div key={index} className="commonBar_placeholderBar" />
          ))}

        <div className="commonBar_noDataMessage">No data available</div>
      </div>
    );

  return (
    <div className="commonBar_container" style={{ height, width }}>
      {data.map((item, index) => (
        <BarItem
          key={item.id || `${item.label}-${index}`}
          {...item}
          barFillColor={barFillColor}
          isTextVertical={isTextVertical}
          height={height}
        />
      ))}
    </div>
  );
};

export default BarGraph;
